<template>
  <div class="blog-container pt-4">
    <b-container class="inner-container">
      <h1 class="page-title">Blog</h1>
      <hr class="mb-5" />

      <BlogFeaturedPost :post="featuredPost" />
      <BlogSecondaryPosts :posts="secondaryPosts" />
      <BlogPosts :posts="posts" />

      <p class="footer-note">
        <em
          >Get started building your own capsules at
          <router-link class="home-link" :to="{ name: 'Blog' }">
            <strong>Unstitched.xyz</strong>
          </router-link>
          and if you enjoyed the posts, please share! ❤️</em
        >
      </p>

      <hr />
      Connect:
      <ConnectButtons class="mb-4" />
    </b-container>
  </div>
</template>

<script>
import ConnectButtons from "@/components/blogEntry/ConnectButtons.vue";
import BlogPosts from "@/components/blog/BlogPosts.vue";
import BlogFeaturedPost from "@/components/blog/BlogFeaturedPost.vue";
import BlogSecondaryPosts from "@/components/blog/BlogSecondaryPosts.vue";
import ENTRIES from "@/components/blog/entries.json";

export default {
  created() {
    this.allPosts = [...ENTRIES["posts"]].sort(
      (a, b) => new Date(b.date) - new Date(a.date)
    );
  },

  mounted() {
    window.analytics.page("Blog");
  },

  data() {
    return {
      allPosts: null,
    };
  },

  components: {
    ENTRIES,
    ConnectButtons,
    BlogPosts,
    BlogFeaturedPost,
    BlogSecondaryPosts,
  },

  computed: {
    featuredPost() {
      return this.allPosts[0];
    },

    secondaryPosts() {
      // Get second and third post
      return this.allPosts.slice(1, 3);
    },

    posts() {
      return this.allPosts.slice(3);
    },
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Josefin+Sans:300,400,700&display=swap");
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_breakpoints.scss";

.blog-container {
  font-family: "Josefin Sans", arial, sans-serif;
  font-weight: 300;
  font-size: 18px;
  color: #6c757d;

  .footer-note {
    font-size: 24px;
    padding-top: 80px;
    padding-bottom: 80px;
  }

  .inner-container {
    padding-right: 0;
    padding-left: 0;
  }

  a {
    transition: 0.3s all ease;
    text-decoration: none;
    color: $primary-blue;
  }

  a:hover {
    text-decoration: none;
    color: darken($primary-accent, 10%);
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    font-family: "Josefin Sans", arial, sans-serif;
  }
}

.post-title {
  margin-top: 8px;
  font-size: 28px;
  line-height: 38px;
  font-weight: 400;
}

.posts__info {
  display: flex;
  margin-top: 12px;
  margin-bottom: 5px;
  align-items: center;

  .info-text.category {
    color: #5b6066;
    font-size: 12px;
    line-height: 22px;
    font-weight: 700;
    letter-spacing: normal;
    text-transform: uppercase;
    cursor: default;
  }

  .info-divider {
    width: 4px;
    height: 4px;
    margin-right: 6px;
    margin-left: 6px;
    border-radius: 12px;
    background-color: #5b6066;
    color: #5b6066;
  }

  .info-text {
    color: #5b6066;
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;
    text-decoration: none;
    text-transform: capitalize;
  }
}
.featured-post {
  .posts__info {
    margin-top: 0;
  }

  .featured__img-wrapper {
    position: relative;
    z-index: 2;
    overflow: hidden;
    width: 751px;
    height: 405px;
    max-height: 405px;
    max-width: 751px;
    min-height: 405px;
    min-width: 751px;
    margin-top: 14px;
    padding-top: 0px;
    border-radius: 6px;
    object-fit: none;

    @media (max-width: 767px) {
      max-height: 181px;
      min-height: 181px;
    }

    @media (max-width: 991px) {
      max-width: 100%;
      min-width: 100%;
    }

    .featured__img {
      position: relative;
      z-index: 1;
      max-height: 100%;
      max-width: 100%;
      min-height: 100%;
      min-width: 100%;
      -webkit-transition: opacity 200ms ease;
      transition: opacity 200ms ease;
      object-fit: cover;

      @media (max-width: 767px) {
        max-height: 181px;
        min-width: 100%;
      }

      @media (max-width: 991px) {
        max-height: none;
        min-height: 300px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Blog.vue